import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { UOM } from '@app/modules/shared/models/engineering-units/unit-of-measurement.model'
import { QueryBuilderService } from '@app/services/query-builder.service'
import { environment } from '@environments/environment'
import { AppSettings } from '@settings/app.settings'

@Injectable({
    providedIn: 'root'
})
export class UOMService {
    private readonly url = `${environment.baseUrl}/api/${AppSettings.apiVersion}/UnitOfMeasurements`

    constructor(private baseApiService: QueryBuilderService) { }

    public getAll(): Observable<UOM[]> {
        return this.baseApiService
            .get<UOM[]>(this.url)
            .pipe(map(response => response.body))
    }
}
